import * as React from 'react';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';

import PageBase from '../../../components/layout/PageBase';
import TrendsForm from '../../../components/pages/tools/trend-spotter/TrendsForm';
import TrendsContent from '../../../components/pages/tools/trend-spotter/TrendsContent';
import Content from '../../../components/pages/tools/content/index';
import ToolsHeader from '../../../components/pages/tools/header/index';
import BackButton from '../../../components/utility/BackButton';

import { isMobile } from '../../../lib/getDeviceSize';

import style from '../../../styles/sass/pages/Tools.module.scss';
import { useRouter } from 'next/router';

export interface Props {
  classes: any;
  trends: any[];
}

const styles = createStyles({
  card: {
    margin: '0 auto',
    padding: 16,
    width: isMobile() ? 350 : 640,
  },
});

export const TrendSpotter = (props: Props) => {
  const [state, setState] = React.useState({ zip: null, noBedrooms: null });
  const router = useRouter();
  const handleStateChange = (values: any) => {
    setState({
      noBedrooms: values.noBedrooms,
      zip: values.zip,
    });
  };

  const content = (needList: boolean, props: Props) => {
    return (
      <Card className={props.classes.card}>
        <CardContent>
          <h3>
            Enter a zip code and number of bedrooms to see how
            <br className="no-mobile" /> rents and property values have been
            changing over the past year.
          </h3>
          <br className="no-mobile" />
          <div className="column">
            <TrendsForm
              zip={state.zip}
              noBedrooms={state.noBedrooms}
              handleStateChange={handleStateChange}
            />
            {needList && <TrendsContent data={props.trends} />}
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <PageBase title="What will my house be worth? | Torii Trend Spotter">
      <BackButton goBack={() => router.push('/tools')} />
      <div
        className={`${style.toolContainer} tool-container ${style.trendSpotter} col-xs-12 center-xs`}
      >
        <ToolsHeader
          title="Trend Spotter"
          slug="trend-spotter"
          subTitle="See where your property value is headed"
        />

        <div className={`col-xs-12 ${style.toolContent} tool-content`}>
          {props.trends.length > 0 ? (
            content(true, props)
          ) : (
            <Content>{content(false, props)}</Content>
          )}
        </div>
      </div>
    </PageBase>
  );
};

const mapStateToProps = (state: any) => ({
  pricePoints: state.listings.pricePoints,
  trends: state.listings.trends,
});

export default withStyles(styles)(connect(mapStateToProps)(TrendSpotter));
